import React from "react";
import { Link } from "react-router-dom";
import PublicLayout from "../../components/layout/PublicLayout";
import { Card } from "../../components/ui/card";
import { FileText, ShieldCheck, Lock } from "lucide-react";

export default function LegalIndex() {
  const items = [
    { to: "/legal/terms/renter", icon: FileText, title: "Renter Terms & Conditions", desc: "For anyone booking or renting a vehicle through RydeXpress." },
    { to: "/legal/terms/host", icon: ShieldCheck, title: "Host Terms & Conditions", desc: "For anyone listing a vehicle on RydeXpress." },
    { to: "/legal/privacy", icon: Lock, title: "Privacy Policy", desc: "How we collect, use, and protect your personal data." },
  ];
  return (
    <PublicLayout>
      <section className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-[10px] uppercase tracking-[0.2em] text-accent font-bold mb-3">Legal</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight mb-8">Legal documents</h1>
        <div className="space-y-3">
          {items.map((item) => (
            <Link key={item.to} to={item.to}>
              <Card className="border-border p-5 hover:shadow-organic transition-shadow flex items-center gap-4">
                <item.icon size={22} className="text-primary shrink-0" />
                <div>
                  <div className="font-display font-semibold">{item.title}</div>
                  <div className="text-sm text-muted-foreground mt-0.5">{item.desc}</div>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
